export enum LanguageCode {
    ENGLISH = 'en',
    DEUTSCH = 'de',
    ITALIANO = 'it',
    MAGYAR = 'hu',
}

export enum CountryCode {
    ENGLISH = 'GB',
    DEUTSCH = 'DE',
    ITALIANO = 'IT',
    MAGYAR = 'HU',
}
